// extracted by mini-css-extract-plugin
export default {"input":"_inputs_input__TRuGe","betAmtInputWrapper":"_inputs_betAmtInputWrapper__JjgKf","label":"_inputs_label__ZZrst","suffix":"_inputs_suffix__we0Ij"};